import styled from "styled-components"
import { devices } from "theme/devices"

const Wrapper = styled.div`
  margin: 3rem 0 0;

  ${devices.mobileL} {
    margin-top: 4rem;
  }

  ${devices.tablet} {
    margin-top: 5rem;
  }

  ${devices.tabletL} {
    margin-top: 2rem;
  }
`

const AddressWrapper = styled.div`
  display: flex;
  margin-top: 2rem;
`

const Address = styled.address`
  display: block;
  margin-top: 0.2rem;
  margin-bottom: 4rem;
  color: ${({ theme }) => theme.neutral60};
  font-style: normal;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.5;
  text-decoration: none;

  ${devices.mobileL} {
    font-size: 1.6rem;
  }

  ${devices.tablet} {
    font-size: 1.8rem;
  }

  ${devices.tabletL} {
    font-size: 1.6rem;
  }

  > ul {
    padding: 0;
    margin: 0;
    list-style-type: none;

    > li {
      display: block;
      font-weight: 400;
    }
  }
`

const ContactInformation = styled.div`
  margin: 0 0 6rem;
`

export default {
  Wrapper,
  AddressWrapper,
  Address,
  ContactInformation,
}
